webpackJsonp([0],{

/***/ "2ZD1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.shape .shape-svg[data-v-11655dde] {\n  height: 80px;\n  width: 80px;\n}\n.shape .shape-path[data-v-11655dde] {\n  fill: white;\n}\n", ""]);

// exports


/***/ }),

/***/ "38RR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("O0fR");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e59739f8", content, true, {});

/***/ }),

/***/ "4kJj":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Qu/o");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("164a0b9e", content, true, {});

/***/ }),

/***/ "7L6Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/coding-photo.b2f142b.jpg";

/***/ }),

/***/ "7odI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("tUjp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0a95109c", content, true, {});

/***/ }),

/***/ "AO6l":
/***/ (function(module, exports) {

module.exports = ["Harry Potter Fangirl","Robotics Enthusiast","Dancing Queen","Stranger Things Fan","Adorer of Puppies","Dual Citizen","Lucid Dreamer","<3's all things geometric"]

/***/ }),

/***/ "CpeW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/reading-photo.47a6e5e.jpg";

/***/ }),

/***/ "MNOZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2ZD1");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("079bd6aa", content, true, {});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./src/helpers/random.js
/* harmony default export */ var random = ({
  name: 'helpers',
  getRandomInt: function getRandomInt(minArg, maxArg) {
    var min = Math.ceil(minArg);
    var max = Math.floor(maxArg);
    return Math.floor(Math.random() * (max - min)) + min;
  },
  getRandomFromArray: function getRandomFromArray(arr) {
    var total = arr.length;
    var index = this.getRandomInt(0, total);
    return arr[index];
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shapes.vue

/* harmony default export */ var Shapes = ({
  name: 'Shapes',
  props: ['shape']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11655dde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shapes.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shape"},[(_vm.shape === 'diamond')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{staticClass:"shape-path",attrs:{"fill":"#000000","stroke":"none","stroke-width":"1"}},[_c('polygon',{attrs:{"points":"50 0 100 50 50 100 0 50"}})])]):(_vm.shape === 'hexagon')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{staticClass:"shape-path",attrs:{"fill":"#000000","stroke":"none","stroke-width":"1"}},[_c('polygon',{attrs:{"points":"50 0 93.3012702 25 93.3012702 75 50 100 6.69872981 75 6.69872981 25"}})])]):(_vm.shape === 'octagon')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{staticClass:"shape-path",attrs:{"fill":"#000000","stroke":"none","stroke-width":"1"}},[_c('polygon',{attrs:{"points":"50 0 85.3553391 14.6446609 100 50 85.3553391 85.3553391 50 100 14.6446609 85.3553391 0 50 14.6446609 14.6446609"}})])]):(_vm.shape === 'circle')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('circle',{staticClass:"shape-path",attrs:{"fill":"#000000","cx":"50","cy":"50","r":"50"}})]):(_vm.shape === 'pentagon')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{staticClass:"shape-path",attrs:{"fill":"#000000","stroke":"none","stroke-width":"1"}},[_c('polygon',{attrs:{"points":"50 4 97.5528258 38.5491503 79.3892626 94.4508497 20.6107374 94.4508497 2.44717419 38.5491503"}})])]):(_vm.shape === 'rectangle')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('rect',{staticClass:"shape-path",attrs:{"fill":"#000000","x":"0","y":"0","width":"100","height":"100"}})]):(_vm.shape === 'triangle')?_c('svg',{staticClass:"shape-svg",attrs:{"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{staticClass:"shape-path",attrs:{"fill":"#000000","stroke":"none","stroke-width":"1"}},[_c('polygon',{attrs:{"points":"50 0 100 100 0 100"}})])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Shapes = (esExports);
// CONCATENATED MODULE: ./src/components/Shapes.vue
function injectStyle (ssrContext) {
  __webpack_require__("MNOZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11655dde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Shapes,
  components_Shapes,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Shapes = (Component.exports);

// EXTERNAL MODULE: ./src/data/work.json
var work = __webpack_require__("QkBs");
var work_default = /*#__PURE__*/__webpack_require__.n(work);

// EXTERNAL MODULE: ./src/data/funFacts.json
var funFacts = __webpack_require__("AO6l");
var funFacts_default = /*#__PURE__*/__webpack_require__.n(funFacts);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Scene.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Scene = ({
  name: 'Scene',
  components: {
    Shapes: src_components_Shapes
  },
  data: function data() {
    return {
      currentWork: work_default.a[0],
      randomFact: this.getRandomFact()
    };
  },

  methods: {
    getRandomFact: function getRandomFact() {
      return random.getRandomFromArray(funFacts_default.a);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bbe753","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scene.vue
var Scene_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene-wrapper"},[_c('div',{staticClass:"shape-clock"},[_c('Shapes',{attrs:{"shape":"hexagon"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"circle"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"triangle"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"diamond"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"hexagon"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"rectangle"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"pentagon"}}),_vm._v(" "),_c('Shapes',{attrs:{"shape":"octagon"}})],1),_vm._v(" "),_c('div',{staticClass:"scene-copy"},[_c('h1',{staticClass:"greeting"},[_vm._v("Oh hi! How’d ya sleep?")]),_vm._v(" "),_c('p',{staticClass:"weather"},[_vm._v("It’s currently 51° and mostly cloudly")]),_vm._v(" "),_c('p',{staticClass:"byline"},[_vm._v("I’m Thalida btw, a "+_vm._s(_vm.currentWork.title)+" and "+_vm._s(_vm.randomFact)+".")])])])}
var Scene_staticRenderFns = []
var Scene_esExports = { render: Scene_render, staticRenderFns: Scene_staticRenderFns }
/* harmony default export */ var components_Scene = (Scene_esExports);
// CONCATENATED MODULE: ./src/components/Scene.vue
function Scene_injectStyle (ssrContext) {
  __webpack_require__("OHdP")
}
var Scene_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Scene___vue_template_functional__ = false
/* styles */
var Scene___vue_styles__ = Scene_injectStyle
/* scopeId */
var Scene___vue_scopeId__ = "data-v-13bbe753"
/* moduleIdentifier (server only) */
var Scene___vue_module_identifier__ = null
var Scene_Component = Scene_normalizeComponent(
  Scene,
  components_Scene,
  Scene___vue_template_functional__,
  Scene___vue_styles__,
  Scene___vue_scopeId__,
  Scene___vue_module_identifier__
)

/* harmony default export */ var src_components_Scene = (Scene_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Icons.vue

/* harmony default export */ var Icons = ({
  name: 'Icons',
  props: ['icon']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-198a2b19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icons.vue
var Icons_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[(_vm.icon === 'code')?_c('svg',{attrs:{"width":"17px","height":"14px","viewBox":"0 0 17 14","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("icon/code")]),_vm._v(" "),_c('desc',[_vm._v("Created with Sketch.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{staticClass:"icon-path icon-code",attrs:{"id":"icon/code","fill":"#000000","fill-rule":"nonzero","stroke":"#000000","stroke-width":"0.5"}},[_c('path',{attrs:{"d":"M3.813,3.096 C3.6,2.934 3.254,2.934 3.042,3.096 L0.16,6.29 C-0.053,6.452 -0.053,6.715 0.16,6.877 C0.228,6.929 3.034,9.877 3.034,9.877 C3.249,10.039 3.597,10.039 3.811,9.877 C4.026,9.715 4.026,9.453 3.811,9.289 L1.273,6.498 L3.813,3.683 C4.026,3.521 4.026,3.258 3.813,3.096 Z M15.84,6.096 C15.762,6.038 12.936,3.096 12.936,3.096 C12.721,2.934 12.373,2.934 12.159,3.096 C11.945,3.258 11.944,3.521 12.159,3.683 L14.708,6.486 L12.159,9.289 C11.944,9.453 11.944,9.715 12.159,9.877 C12.374,10.039 12.722,10.039 12.936,9.877 L15.84,6.683 C16.055,6.521 16.055,6.258 15.84,6.096 Z M11.742,0.068 C11.502,-0.071 11.193,0.011 11.053,0.252 L4.046,13.254 C3.907,13.492 3.989,13.795 4.229,13.934 C4.469,14.071 4.776,13.989 4.914,13.75 L11.928,0.753 C12.066,0.513 11.984,0.207 11.742,0.068 Z","id":"Shape"}})])])]):(_vm.icon === 'dribbble')?_c('svg',{attrs:{"width":"15px","height":"16px","viewBox":"0 0 15 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("icon/dribbble")]),_vm._v(" "),_c('desc',[_vm._v("Created with Sketch.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{staticClass:"icon-path icon-dribbble",attrs:{"id":"icon/dribbble","fill":"#000000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M7.5,0.999 C3.358,0.999 0,4.357 0,8.499 C0,12.642 3.358,15.999 7.5,15.999 C11.643,15.999 15,12.642 15,8.499 C15,4.357 11.643,0.999 7.5,0.999 Z M13.488,8.378 C11.896,7.972 10.504,7.899 9.297,8.053 C9.094,7.583 8.873,7.103 8.621,6.611 C9.693,6.115 10.85,5.467 12.084,4.632 C12.941,5.647 13.459,6.952 13.488,8.378 Z M7.5,2.499 C8.895,2.499 10.176,2.979 11.196,3.778 C10.727,4.183 9.704,4.967 8.133,5.709 C7.558,4.694 6.881,3.665 6.072,2.677 C6.53,2.565 7.006,2.499 7.5,2.499 Z M4.942,3.078 C5.398,3.697 6.152,4.79 6.949,6.203 C5.217,6.824 3.209,7.087 1.686,7.073 C2.12,5.304 3.328,3.841 4.942,3.078 Z M1.5,8.499 C1.5,8.383 1.519,8.27 1.525,8.155 C2.666,8.246 4.718,8.164 7.442,7.111 C7.639,7.489 7.833,7.898 8.025,8.31 C5.135,9.128 3.527,11.22 2.868,12.314 C2.014,11.276 1.5,9.948 1.5,8.499 Z M7.5,14.499 C6.065,14.499 4.748,13.994 3.716,13.153 C5.038,10.912 6.789,9.818 8.479,9.349 C9.077,10.778 9.604,12.34 9.905,13.994 C9.168,14.317 8.355,14.499 7.5,14.499 Z M10.979,13.381 C10.903,12.95 10.565,11.26 9.733,9.106 C11.315,8.914 12.702,9.155 13.436,9.338 C13.201,11.003 12.287,12.447 10.979,13.381 Z","id":"Shape"}})])])]):(_vm.icon === 'link')?_c('svg',{attrs:{"width":"15px","height":"15px","viewBox":"0 0 15 15","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_vm._v("icon/link")]),_vm._v(" "),_c('desc',[_vm._v("Created with Sketch.")]),_vm._v(" "),_c('defs'),_vm._v(" "),_c('g',{attrs:{"id":"Symbols","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{staticClass:"icon-path icon-link",attrs:{"id":"icon/link","fill":"#000000","fill-rule":"nonzero","stroke":"#000000","stroke-width":"0.5"}},[_c('path',{attrs:{"d":"M6.74213498,12.4334636 L5.78845078,13.3871477 L5.4708477,13.7047508 C4.94500898,14.2305895 4.08931803,14.2305895 3.56347931,13.7047508 L2.29219203,12.4334636 C1.76635332,11.9076248 1.76635332,11.0528088 2.29219203,10.5260952 L6.42453189,6.39463025 C6.95037061,5.86791659 7.80518662,5.86791659 8.33190028,6.39463025 L8.96710645,7.03071136 L9.28470953,7.34831444 C9.3722035,7.43668334 9.48769553,7.47955538 9.60231262,7.47955538 C9.71692971,7.47955538 9.83329668,7.4358084 9.9199157,7.34831444 C10.0957786,7.17332652 10.0957786,6.88897114 9.9199157,6.71223333 L9.60231262,6.39463025 L8.96623151,5.75854914 C8.09041694,4.88185963 6.66426535,4.88185963 5.78845078,5.75854914 L1.65611093,9.890889 C0.780296358,10.7675785 0.780296358,12.1937301 1.65611093,13.0695447 L2.9273982,14.3408319 C3.80321277,15.2175214 5.22936436,15.2166465 6.10605387,14.3408319 L6.42453189,14.0232289 L7.37734115,13.0695447 C7.55320401,12.8936818 7.55320401,12.6093264 7.37734115,12.4334636 C7.20235322,12.2584756 6.91799784,12.2584756 6.74213498,12.4334636 Z M14.3191121,2.847625 L13.1501928,1.67783072 C12.2612541,0.788017117 10.7782315,0.769643385 9.91204125,1.63495868 L9.60231262,1.9446873 L8.64862842,2.89924644 C8.4736405,3.07423436 8.4736405,3.35858974 8.64862842,3.53445261 C8.73787227,3.62282151 8.85161442,3.66656849 8.96710645,3.66656849 C9.08172354,3.66656849 9.19809051,3.62194657 9.28470953,3.53445261 L10.2383937,2.58076841 L10.5481224,2.27103978 C11.060837,1.7592001 11.9803985,1.77844877 12.5149866,2.31391183 L13.6856559,3.48370611 C14.220244,4.01916916 14.2394926,4.93785577 13.726778,5.44969545 L10.8657254,8.31074803 L9.74930248,9.42629606 C9.20421509,9.97138344 8.14291332,10.021255 7.64507267,9.52253941 L7.10960962,8.9879513 C7.09298577,8.97132745 7.08161155,8.94857902 7.06673758,8.93020529 L7.05973806,8.9372048 L6.74213498,8.62047666 C6.56627211,8.44461379 6.28191673,8.44461379 6.10605387,8.62047666 C5.930191,8.79546458 5.930191,9.07981996 6.10605387,9.25655777 L6.47352851,9.62403241 L7.00899156,10.1586205 L7.05886312,10.210242 C7.08423637,10.2338653 7.11485926,10.2478644 7.14373227,10.2662381 C7.97579985,10.9583153 9.34158061,10.9233178 10.2217699,10.194493 L10.2375188,10.210242 C10.2681417,10.1778692 10.2952648,10.1437465 10.3250128,10.1104988 C10.3433865,10.0930001 10.3661349,10.0807509 10.3845086,10.0623772 L14.3611092,6.08577656 C15.2281744,5.21871139 15.2089257,3.7374386 14.3191121,2.847625 Z","id":"Shape"}})])])]):_vm._e()])}
var Icons_staticRenderFns = []
var Icons_esExports = { render: Icons_render, staticRenderFns: Icons_staticRenderFns }
/* harmony default export */ var components_Icons = (Icons_esExports);
// CONCATENATED MODULE: ./src/components/Icons.vue
function Icons_injectStyle (ssrContext) {
  __webpack_require__("38RR")
}
var Icons_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Icons___vue_template_functional__ = false
/* styles */
var Icons___vue_styles__ = Icons_injectStyle
/* scopeId */
var Icons___vue_scopeId__ = "data-v-198a2b19"
/* moduleIdentifier (server only) */
var Icons___vue_module_identifier__ = null
var Icons_Component = Icons_normalizeComponent(
  Icons,
  components_Icons,
  Icons___vue_template_functional__,
  Icons___vue_styles__,
  Icons___vue_scopeId__,
  Icons___vue_module_identifier__
)

/* harmony default export */ var src_components_Icons = (Icons_Component.exports);

// EXTERNAL MODULE: ./src/data/projects.json
var projects = __webpack_require__("dHVI");
var projects_default = /*#__PURE__*/__webpack_require__.n(projects);

// EXTERNAL MODULE: ./src/data/extras.json
var extras = __webpack_require__("iE6M");
var extras_default = /*#__PURE__*/__webpack_require__.n(extras);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Content.vue







/* harmony default export */ var Content = ({
  name: 'Content',
  components: {
    Icons: src_components_Icons
  },
  data: function data() {
    var data = {
      projects: projects_default.a,
      work: work_default.a,
      extras: extras_default.a,
      links: {
        queer: ['https://www.urbandictionary.com/define.php?term=queer', 'https://www.huffingtonpost.com/nadia-cho/being-queer-means_b_3510828.html', 'https://www.uua.org/lgbtq/identity/queer'],
        cisgender: ['http://www.transstudent.org/definitions', 'https://www.healthline.com/health/transgender/what-is-cis', 'https://www.advocate.com/transgender/2015/07/31/true-meaning-word-cisgender'],
        bubbleTea: ['https://www.youtube.com/watch?v=xebewT6lh2k', 'https://www.youtube.com/watch?v=Ct6BUPvE2sM']
      }
    };

    data.queerLink = random.getRandomFromArray(data.links.queer);
    data.cisgenderLink = random.getRandomFromArray(data.links.cisgender);
    data.bubbleTeaLink = random.getRandomFromArray(data.links.bubbleTea);

    return data;
  },

  computed: {
    featuredProject: function featuredProject() {
      return this.projects.find(function (obj) {
        return obj.featured === true;
      });
    }
  },
  methods: {
    onQueerClick: function onQueerClick() {
      this.queerLink = random.getRandomFromArray(this.links.queer);
    },
    onCisgenderClick: function onCisgenderClick() {
      this.cisgenderLink = random.getRandomFromArray(this.links.cisgender);
    },
    onBubbleTeaClick: function onBubbleTeaClick() {
      this.bubbleTeaLink = random.getRandomFromArray(this.links.bubbleTea);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e165b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content.vue
var Content_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"bg-accent-light"},[_c('h1',[_vm._v("Projects")]),_vm._v(" "),_vm._l((_vm.projects),function(project){return (!project.hidden)?_c('div',{staticClass:"project"},[_c('h2',[_c('a',{attrs:{"href":project.link,"target":"_blank"}},[_vm._v(_vm._s(project.title))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(project.description))]),_vm._v(" "),_c('p',{staticClass:"project-links"},[(!project.hideLinkIcon)?_c('a',{staticClass:"fade-hover",attrs:{"href":project.link,"target":"_blank"}},[_c('Icons',{attrs:{"icon":"link"}})],1):_vm._e(),_vm._v(" "),(project.github)?_c('a',{staticClass:"fade-hover",attrs:{"href":project.github,"target":"_blank"}},[_c('Icons',{attrs:{"icon":"code"}})],1):_vm._e(),_vm._v(" "),(project.dribbble)?_c('a',{staticClass:"fade-hover",attrs:{"href":project.dribbble,"target":"_blank"}},[_c('Icons',{attrs:{"icon":"dribbble"}})],1):_vm._e()])]):_vm._e()})],2),_vm._v(" "),(_vm.featuredProject)?_c('section',{staticClass:"featured-project"},[_c('h1',[_vm._v("Featured Project")]),_vm._v(" "),_vm._l((_vm.featuredProject.longDescription),function(paragraph){return _c('p',[_vm._v(_vm._s(paragraph))])})],2):_vm._e(),_vm._v(" "),_c('section',{staticClass:"photo reading-photo"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('section',{staticClass:"about"},[_c('h1',[_vm._v("About")]),_vm._v(" "),_c('p',[_vm._v("\n      I’m a "),_c('a',{attrs:{"href":_vm.queerLink,"target":"_blank"},on:{"click":function($event){_vm.onQueerClick()}}},[_vm._v("queer")]),_vm._v(" Trinidadian-American "),_c('a',{attrs:{"href":_vm.cisgenderLink,"target":"_blank"},on:{"click":function($event){_vm.onCisgenderClick()}}},[_vm._v("cisgender")]),_vm._v(" woman of color. \n      I work as a Senior Software Engineer at "),_c('a',{attrs:{"href":"https://etsy.com","target":"_blank"}},[_vm._v("Etsy")]),_vm._v(" in New York, and I’ve been \n      active in the engineering world for over 6 years.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      I was lucky enough to have a supportive mother, who got me thalida.com \n      for my 16th birthday. It was one of the best gifts I’ve ever received, \n      and is the reason I've become the developer I am today.\n    ")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n      I’m generally full of questions, and "),_c('a',{attrs:{"href":_vm.bubbleTeaLink,"target":"_blank"},on:{"click":function($event){_vm.onBubbleTeaClick()}}},[_vm._v("bubble tea")]),_vm._v(".\n    ")])]),_vm._v(" "),_c('section',{staticClass:"photo coding-photo"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('section',{staticClass:"work"},[_c('h1',[_vm._v("Work History")]),_vm._v(" "),_vm._l((_vm.work),function(job){return (!job.hidden)?_c('div',{staticClass:"job"},[_c('h3',{staticClass:"job-header"},[_c('span',{staticClass:"job-company"},[_vm._v(_vm._s(job.company))]),_vm._v(" "),_c('span',{staticClass:"job-duration"},[_vm._v(_vm._s(job.duration))])]),_vm._v(" "),_c('p',{staticClass:"job-title"},[_vm._v(_vm._s(job.title))])]):_vm._e()})],2),_vm._v(" "),_c('section',{staticClass:"extras bg-accent-light"},[_c('h1',[_vm._v("In the Wild")]),_vm._v(" "),_vm._l((_vm.extras),function(extra){return (!extra.hidden)?_c('div',{staticClass:"extra"},[_c('h2',[_c('a',{attrs:{"href":extra.link,"target":"_blank"}},[_vm._v(_vm._s(extra.title))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(extra.description))])]):_vm._e()})],2),_vm._v(" "),_vm._m(3)])}
var Content_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"caption"},[_vm._v("\n      Me \"reading\", a \n      "),_c('a',{attrs:{"href":"https://www.flickr.com/photos/wocintechchat/albums","target":"_blank"}},[_vm._v("#WOCinTech Chat stock photo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      I now work with an amazing team during the day, and in the wee hours of \n      the night I hack away at one of my many side projects. I'm always \n      looking for a coding buddy, so if you're interested, get in touch! \n      "),_c('a',{attrs:{"href":"mailto:hello@thalida.com?subject=Oh%20hi!","target":"_blank"}},[_vm._v("hello@thalida.com")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"caption"},[_vm._v("\n      Me \"coding\", a \n      "),_c('a',{attrs:{"href":"https://www.flickr.com/photos/wocintechchat/albums","target":"_blank"}},[_vm._v("#WOCinTech Chat stock photo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer clearfix bg-accent"},[_c('div',{staticClass:"footer-section text-left"},[_c('span',{staticClass:"footer-credit"},[_vm._v("\n        Powered by "),_c('a',{attrs:{"href":"https://darksky.net/poweredby/","target":"_blank"}},[_vm._v("DarkSky")])]),_vm._v(" "),_c('span',{staticClass:"footer-credit"},[_vm._v("\n        View source on "),_c('a',{attrs:{"href":"https://github.com/thalida","target":"_blank"}},[_vm._v("Github")])])]),_vm._v(" "),_c('div',{staticClass:"footer-section text-right"},[_c('a',{attrs:{"href":"https://twitter.com/thalidanoel","target":"_blank"}},[_vm._v("@thalidanoel")])])])}]
var Content_esExports = { render: Content_render, staticRenderFns: Content_staticRenderFns }
/* harmony default export */ var components_Content = (Content_esExports);
// CONCATENATED MODULE: ./src/components/Content.vue
function Content_injectStyle (ssrContext) {
  __webpack_require__("7odI")
}
var Content_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Content___vue_template_functional__ = false
/* styles */
var Content___vue_styles__ = Content_injectStyle
/* scopeId */
var Content___vue_scopeId__ = "data-v-79e165b0"
/* moduleIdentifier (server only) */
var Content___vue_module_identifier__ = null
var Content_Component = Content_normalizeComponent(
  Content,
  components_Content,
  Content___vue_template_functional__,
  Content___vue_styles__,
  Content___vue_scopeId__,
  Content___vue_module_identifier__
)

/* harmony default export */ var src_components_Content = (Content_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue




/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Scene: src_components_Scene,
    Content: src_components_Content
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2710b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-left"},[_c('Scene')],1),_vm._v(" "),_c('div',{staticClass:"app-right"},[_c('Content')],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("4kJj")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "O0fR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.icon .icon-path[data-v-198a2b19] {\n  fill: #1C1F40;\n}\n.icon .icon-code[data-v-198a2b19],\n.icon .icon-link[data-v-198a2b19] {\n  stroke: #1C1F40;\n}\n", ""]);

// exports


/***/ }),

/***/ "OHdP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lOg/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("311cf49b", content, true, {});

/***/ }),

/***/ "QkBs":
/***/ (function(module, exports) {

module.exports = [{"company":"Etsy","title":"Senior Software Engineer","duration":"May 2017 - Now","location":{"city":"New York City","state":"New York","country":"United States"}},{"company":"Kinnek","title":"Senior Frontend Engineer","duration":"Nov 2015 - May 2017","location":{"city":"New York City","state":"New York","country":"United States"}},{"company":"OkCupid/DateHookup","title":"Frontend Developer","duration":"Jan 2014 - Nov 2015","location":{"city":"New York City","state":"New York","country":"United States"}},{"company":"Webs","title":"Frontend Intern","duration":"Jan 2013 - Jan 2014","location":{"city":"Silverspring","state":"Maryland","country":"United States"}},{"company":"NASA Goddard","title":"Software Engineering Intern","duration":"Mar 2010 - Jan 2013","location":{"city":"Greenbelt","state":"Maryland","country":"United States"}}]

/***/ }),

/***/ "Qu/o":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody,\n#app {\n  height: 100%;\n}\nhtml {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*, *:before, *:after {\n  -webkit-box-sizing: inherit;\n          box-sizing: inherit;\n}\nbody {\n  margin: 0;\n  padding: 0;\n}\n#app {\n  display: block;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  color: #1C1F40;\n  font-family: 'Roboto Mono', monospace;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.app-left {\n  height: 98%;\n}\n.app-left,\n.app-right {\n  display: block;\n  position: relative;\n}\n@media (min-width: 900px) {\n.app-left,\n  .app-right {\n    display: block;\n    position: fixed;\n    width: 50%;\n    top: 0;\n    height: 100%;\n}\n.app-left {\n    left: 0;\n    overflow: hidden;\n}\n.app-right {\n    right: 0;\n    overflow: auto;\n}\n}\na {\n  color: #1C1F40;\n  font-weight: 700;\n  text-decoration: none;\n  opacity: 1;\n}\na:not(.fade-hover):hover {\n    text-decoration: underline;\n}\na.fade-hover:hover {\n    opacity: 0.6;\n}\n.text-left {\n  text-align: left;\n}\n.text-right {\n  text-align: right;\n}\n.clearfix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n", ""]);

// exports


/***/ }),

/***/ "dHVI":
/***/ (function(module, exports) {

module.exports = [{"hidden":false,"title":"bit.ly roulette","description":"random bit.ly url","link":"https://thalida.github.io/bitly-roulette/","github":"https://github.com/thalida/bitly-roulette"},{"hidden":false,"title":"Timezone","description":"Convert any datetime from one timezone to another","link":"https://thalida.github.io/Timezone/","github":"https://github.com/thalida/Timezone"},{"hidden":true,"title":"IsTrumpStillF*ingPresident?","description":"Answers the question. Attempts to provide some joy.","link":"https://istrumpstillfuckingpresident.co","github":"https://github.com/thalida/istrumpstillfuckingpresident"},{"hidden":true,"title":"blerDCon","description":"BlerDCon will be the first nerd convention to ever be truly universal. We’re structured to cater to minority nerds in all genres. To ensure that the inclusive experience we offer has something for you.","link":"http://blerdcon.com"},{"hidden":false,"title":"ShapeConnector","description":"A puzzle game where the goal is to get from one shape to another in a specified amount of moves.","link":"http://shapeconnector.com","github":"https://github.com/thalida/ShapeConnector","dribbble":"https://dribbble.com/thalida/projects/307956-ShapeConnector"},{"hidden":false,"title":"CiphersCodes","description":"ciphers.codes is a ciphers translator which will encode + decode a given piece of text.","link":"http://ciphers.codes","github":"https://github.com/thalida/CiphersCodes","dribbble":"https://dribbble.com/thalida/projects/307949-EncodeDecode"},{"hidden":true,"title":"FancyCard","description":"Various demos of my personal website (thalida.com) developed in various frameworks and methods. A new demo will be added as the front-end development landscape changes, and will showcase the new techniques that have become part of the modern standard.","link":"https://github.com/thalida/FancyCard","github":"https://github.com/thalida/FancyCard","dribbble":"https://dribbble.com/shots/2303709-Personal-Website"},{"hidden":false,"title":"WordBird","description":"A chrome plugin which will replace any words you choose with another one.","link":"https://github.com/thalida/WordBird","github":"https://github.com/thalida/WordBird","hideLinkIcon":true},{"hidden":false,"title":"WelcomeBot","description":"A slack bot which will greet new members to a channel with a basic introduction and a way to find out more information.","link":"https://github.com/thalida/WelcomeBot","github":"https://github.com/thalida/WelcomeBot","hideLinkIcon":true},{"hidden":true,"featured":true,"title":"Live-ish Scene","longDescription":["The Live-ish Scene on the left automatically updates throughout the day. This project was a very fun experiment for myself, and is something that I find myself coming back to and making little tweaks and improvements on every few months.","Basically, everything is dynamic and changes based on time, weather, number of visits, if mercury is in retrograde. Well, not the last part. But, you get the idea. Stuff moves. Text Changes. Cool stuff. Oh, and I made the graphics."]}]

/***/ }),

/***/ "dUom":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/etsy-photo.87e0e7d.png";

/***/ }),

/***/ "iE6M":
/***/ (function(module, exports) {

module.exports = [{"title":"Responsive Web Design Podcast","link":"https://responsivewebdesign.com/podcast/thalida-noel/","description":"This week the spotlight is on Thalida Noel, whose path to becoming a front-end engineer includes robotics, NASA, OkCupid, and now Etsy."},{"title":"WOCinTech Chat Photoshoots","link":"https://www.flickr.com/photos/wocintechchat/albums","description":"I particated in two of the WOCInTechChat Photoshoots. The photos are stock photos, that can be used under a creative commons license with attribution."},{"title":"The Journey Towards Staying","link":"https://medium.com/@thalidanoel/the-journey-towards-staying-af25c4d78da5#.abu2ga2eq","description":"One of the most consequential issues affecting young people is also the most ignored."},{"title":"Dribbble","link":"https://dribbble.com/thalida","description":"Check out my designs and get a preview of the projects I'm currently working on."}]

/***/ }),

/***/ "lOg/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.scene-wrapper[data-v-13bbe753] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  height: 100%;\n  overflow: hidden;\n  background-color: #1C1F40;\n}\n.scene-copy[data-v-13bbe753] {\n  display: block;\n  position: relative;\n  margin: 0 64px;\n}\n.scene-copy .greeting[data-v-13bbe753],\n  .scene-copy .weather[data-v-13bbe753],\n  .scene-copy .byline[data-v-13bbe753] {\n    padding: 0;\n    margin: 0;\n    color: #FFFFFF;\n}\n.scene-copy .greeting[data-v-13bbe753] {\n    padding: 0;\n    margin: 0;\n    font-family: 'Bungee', cursive;\n    font-size: 36px;\n    color: #FFFFFF;\n    text-shadow: 0 0 6px #1C1F40;\n}\n.scene-copy .weather[data-v-13bbe753] {\n    margin-top: 4px;\n    font-family: 'Signika', sans-serif;\n    font-size: 16px;\n    text-shadow: 0 0 6px #1C1F40;\n}\n.scene-copy .byline[data-v-13bbe753] {\n    margin-top: 24px;\n    font-size: 14px;\n    letter-spacing: -0.5px;\n    line-height: 22px;\n    text-shadow: 0 0 6px #1C1F40;\n}\n.shape-clock[data-v-13bbe753] {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.shape-clock .shape[data-v-13bbe753] {\n    display: block;\n    position: absolute;\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(1) {\n      top: 40px;\n      left: calc(50% - 40px);\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(2) {\n      top: calc(15% - 40px);\n      right: calc(15% - 40px);\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(3) {\n      right: -20px;\n      top: calc(55% - 40px);\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(4) {\n      bottom: calc(1% - 40px);\n      right: calc(18% - 40px);\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(5) {\n      bottom: 40px;\n      left: calc(50% - 40px);\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(6) {\n      bottom: 20px;\n      left: -26.66667px;\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(7) {\n      left: -40px;\n      top: calc(50% - 40px);\n}\n.shape-clock .shape[data-v-13bbe753]:nth-child(8) {\n      top: calc(20% - 40px);\n      left: 40px;\n}\n@media (max-width: 480px) {\n.shape-clock[data-v-13bbe753] {\n      top: -10%;\n      left: -10%;\n      width: 120%;\n      height: 120%;\n}\n}\n", ""]);

// exports


/***/ }),

/***/ "tUjp":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nh1[data-v-79e165b0] {\n  font-size: 18px;\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.8);\n  padding: 0;\n  margin: 0;\n}\nh2[data-v-79e165b0] {\n  font-weight: 900;\n  font-size: 14px;\n  line-height: 22px;\n  padding: 0;\n  margin: 0;\n}\np[data-v-79e165b0],\n.p1[data-v-79e165b0] {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  padding: 0;\n  margin: 0;\n}\nsection[data-v-79e165b0] {\n  margin: 0;\n  padding: 32px;\n}\n@media (min-width: 640px) and (max-width: 900px) {\nsection[data-v-79e165b0] {\n      padding: 48px;\n}\n}\n@media (min-width: 900px) {\nsection[data-v-79e165b0] {\n      padding: 64px;\n}\n}\n.bg-accent[data-v-79e165b0] {\n  background-color: #95FFE7;\n}\n.bg-accent-light[data-v-79e165b0] {\n  background-color: rgba(149, 255, 232, 0.1);\n}\n.photo[data-v-79e165b0] {\n  display: block;\n  padding: 0;\n  height: 280px;\n  width: 100%;\n  background-color: rgba(149, 255, 232, 0.1);\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.photo.etsy-photo[data-v-79e165b0] {\n    background-image: url(" + escape(__webpack_require__("dUom")) + ");\n    background-position: center bottom;\n}\n.photo.reading-photo[data-v-79e165b0] {\n    background-image: url(" + escape(__webpack_require__("CpeW")) + ");\n    background-position: center 60%;\n}\n@media (min-width: 500px) {\n.photo.reading-photo[data-v-79e165b0] {\n        background-position: center 50%;\n}\n}\n.photo.coding-photo[data-v-79e165b0] {\n    background-image: url(" + escape(__webpack_require__("7L6Q")) + ");\n    background-position: center center;\n}\n.caption[data-v-79e165b0] {\n  padding: 4px 8px;\n  background-color: rgba(0, 0, 0, 0.02);\n  font-weight: 400;\n  font-size: 10px;\n  color: rgba(28, 31, 64, 0.5);\n  text-align: right;\n}\n.caption a[data-v-79e165b0] {\n    color: rgba(28, 31, 64, 0.7);\n}\n.project[data-v-79e165b0],\n.extra[data-v-79e165b0] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.project[data-v-79e165b0]:last-child,\n  .extra[data-v-79e165b0]:last-child {\n    padding-bottom: 0;\n}\n.project .project-links[data-v-79e165b0],\n  .extra .project-links[data-v-79e165b0] {\n    margin-top: 8px;\n}\n.project .project-links a[data-v-79e165b0],\n    .extra .project-links a[data-v-79e165b0] {\n      margin-right: 8px;\n}\n.featured-project p[data-v-79e165b0],\n.about p[data-v-79e165b0] {\n  padding-top: 16px;\n}\n.work .job[data-v-79e165b0] {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.work .job-header[data-v-79e165b0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0;\n  margin: 0;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n}\n.work .job-company[data-v-79e165b0] {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n}\n.work .job-duration[data-v-79e165b0] {\n  display: none;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 auto;\n          flex: 0 1 auto;\n  text-align: right;\n  font-weight: 300;\n  font-size: 14px;\n}\n@media (min-width: 640px) {\n.work .job-duration[data-v-79e165b0] {\n    display: block;\n}\n}\n.footer[data-v-79e165b0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 16px;\n}\n.footer .footer-section[data-v-79e165b0] {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 auto;\n            flex: 0 1 auto;\n    width: 50%;\n}\n.footer .footer-credit[data-v-79e165b0] {\n    display: block;\n    text-transform: uppercase;\n    font-size: 10px;\n    padding: 4px 0;\n}\n@media (min-width: 640px) and (max-width: 900px) {\n.footer[data-v-79e165b0] {\n      padding-left: 48px;\n      padding-right: 48px;\n}\n}\n@media (min-width: 900px) {\n.footer[data-v-79e165b0] {\n      padding-left: 64px;\n      padding-right: 64px;\n}\n}\n", ""]);

// exports


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.03813841f0f5778830b4.js